import { z } from "zod";
export const BroadcastColorSchema = z.enum(["RED", "GREEN", "BLUE", "WHITE"]);
export const BroadcastEmojiSchema = z.enum(["😀", "❤️", "👏", "🔥", "🎉", "⭐", "👍", "👋"]);
export const BroadcastCountdownSchema = z.union([
    z.literal(3), z.literal(5), z.literal(10), z.literal(30), z.literal(60),
]);
export const BroadcastColorModeSchema = z.enum(["solid", "blink"]);
export const BroadcastBlinkIntervalSchema = z.union([
    z.literal(100), z.literal(200), z.literal(300), z.literal(500),
]);
export const BroadcastHoldDurationSchema = z.union([
    z.literal(1), z.literal(2), z.literal(3), z.literal(5), z.literal("continuous"),
]);
export const BroadcastColorRequestSchema = z.object({
    color: BroadcastColorSchema,
    mode: BroadcastColorModeSchema.default("solid"),
    blinkIntervalMs: BroadcastBlinkIntervalSchema.default(200),
    holdDuration: BroadcastHoldDurationSchema.default("continuous"),
});
export const BroadcastEmojiRequestSchema = z.object({ emoji: BroadcastEmojiSchema });
export const BroadcastCountdownRequestSchema = z.object({ seconds: BroadcastCountdownSchema });
